import { jsx as _jsx } from "react/jsx-runtime";
import DateRangePickerWrapper from './DateRangePickerWrapper';
export const prefix = 'materialui-daterange-picker';
const DateRangePickerExporter = (props) => (_jsx(DateRangePickerWrapper, { ...props }));
export default DateRangePickerExporter;
